export default __webpack_public_path__ + "static/media/Untitled_design__54_-removebg-preview.ea304cc1.png";